import { FDDialogContent } from '@facet-wealth/design';
import React from 'react';
import PropTypes from 'prop-types';


export const DialogContent = (props) => {
  const {
    children,
    scrollKey,
  } = props;

  return (
    <FDDialogContent scrollKey={scrollKey}>
      {children}
    </FDDialogContent>
  );
};

DialogContent.defaultProps = {
  scrollKey: undefined,
};

DialogContent.propTypes = {
  children: PropTypes.node.isRequired,
  scrollKey: PropTypes.string,
};
